import { Component, Input, OnDestroy, OnInit, Optional } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { Subscription } from 'rxjs';

interface ConsentDocument {
  labelKey: string;
  urlPl: string;
  urlEn: string;
  checked: boolean;
}

@Component({
  selector: 'app-consent-documents',
  templateUrl: './consent-documents.component.html',
  styleUrls: ['./consent-documents.component.scss']
})
export class ConsentDocumentsComponent implements OnInit, OnDestroy {

  // Parent form must contain the `ruleAccept` and `rodoSecond` controls.
  @Input() parentForm: FormGroup;

  public lang = false;
  public submitAttempted = false;

  private submitSubscription: Subscription;

  constructor(@Optional() private formGroupDirective: FormGroupDirective) {
  }

  public documents: ConsentDocument[] = [
    {
      labelKey: 'CONSENT_DOCS.DOC_PATIENT_CLAUSE',
      urlPl: 'https://sidly.eu/manual/20260512_SiDLY_Klauzula_Pacjent.pdf',
      urlEn: 'https://sidly.eu/manual/20260512_SiDLY_Patient_Information_Notice_EN.pdf',
      checked: false
    },
    {
      labelKey: 'CONSENT_DOCS.DOC_AI_NOTE',
      urlPl: 'https://sidly.eu/manual/20260512_SiDLY_Nota_Transparentnosci_AI.pdf',
      urlEn: 'https://sidly.eu/manual/20260512_SiDLY_AI_Transparency_Notice_EN.pdf',
      checked: false
    },
    {
      labelKey: 'CONSENT_DOCS.DOC_PRIVACY',
      urlPl: 'https://sidly.eu/manual/20260512_SiDLY_Polityka_Prywatnosci.pdf',
      urlEn: 'https://sidly.eu/manual/20260512_SiDLY_Privacy_Policy_EN.pdf',
      checked: false
    },
    {
      labelKey: 'CONSENT_DOCS.DOC_COOKIES',
      urlPl: 'https://sidly.eu/manual/20260512_SiDLY_Polityka_Cookies.pdf',
      urlEn: 'https://sidly.eu/manual/20260512_SiDLY_Cookie_Policy_EN.pdf',
      checked: false
    },
    {
      labelKey: 'CONSENT_DOCS.DOC_RULES',
      urlPl: 'https://sidly.eu/manual/20260513_SiDLY_-_Regulamin_platformy_medycznej.pdf',
      urlEn: 'https://sidly.eu/manual/20260513_SiDLY_Medical_Platform_Terms_and_Conditions_EN.pdf',
      checked: false
    }
  ];

  ngOnInit() {
    this.lang = window.localStorage['lang'] === 'pl';

    if (this.parentForm && this.parentForm.get('ruleAccept').value === true) {
      this.documents.forEach(doc => doc.checked = true);
    }

    if (this.formGroupDirective) {
      this.submitSubscription = this.formGroupDirective.ngSubmit.subscribe(() => this.submitAttempted = true);
    }
  }

  ngOnDestroy() {
    if (this.submitSubscription) {
      this.submitSubscription.unsubscribe();
    }
  }

  get ruleAcceptControl() {
    return this.parentForm ? this.parentForm.get('ruleAccept') : null;
  }

  get rodoSecondControl() {
    return this.parentForm ? this.parentForm.get('rodoSecond') : null;
  }

  toggleDocument(doc: ConsentDocument, event: Event): void {
    doc.checked = (event.target as HTMLInputElement).checked;
    this.updateRuleAccept();
  }

  selectAllRequired(): void {
    this.documents.forEach(doc => doc.checked = true);
    this.updateRuleAccept();
  }

  readDocument(doc: ConsentDocument, event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    const url = this.lang ? doc.urlPl : doc.urlEn;
    if (url) {
      window.open(url, '_blank');
    }
  }

  hasDocumentUrl(doc: ConsentDocument): boolean {
    return !!(this.lang ? doc.urlPl : doc.urlEn);
  }

  private updateRuleAccept(): void {
    const allChecked = this.documents.every(doc => doc.checked);
    const control = this.ruleAcceptControl;
    if (control) {
      control.setValue(allChecked ? true : false);
      control.markAsTouched();
    }
  }
}
